<template>
  <el-dialog custom-class="dialog-container"
             :visible.sync="show"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             width="740px"
             top="5vh">
    <div class="ad-container">
      <img class="ad-close"
           src="~/assets/pics/ad/close.png"
           @click="closeDialog"
           alt="">
      <img class="ad-skip"
           src="~/assets/pics/ad/skip_cn.png"
           v-if="imgIndex!==3 && language==='cn'"
           @click="closeDialog"
           alt="">
      <img class="ad-skip"
           src="~/assets/pics/ad/skip_en.png"
           v-if="imgIndex!==3 && language==='en'"
           @click="closeDialog"
           alt="">
      <img class="ad-back"
           src="~/assets/pics/ad/backward.png"
           v-if="imgIndex!==1"
           @click="goBack"
           alt="">
      <img class="ad-next"
           src="~/assets/pics/ad/foward.png"
           v-if="imgIndex!==3"
           @click="goNext"
           alt="">
      <img class="ad-img"
           :style="{'opacity':imgOpacity}"
           :src="require(`../../assets/pics/ad/${showStep(imgIndex)}`)"
           alt="" />

    </div>
  </el-dialog>
</template>

<script>
export default {
  inject: ['homeTemplate'],
  data () {
    return {
      imgIndex: 1,
      imgOpacity: 1,
      timerDelay: '',
      lan: 'cn',
    };
  },
  watch: {
    language (val) {
      this.lan = val;
    },
  },
  computed: {
    showStep () {
      return (step) => {
        switch (step) {
          case 1:
            return this.lan === 'cn' ? 'ad_cn1.png' : 'ad_en1.png';
          case 2:
            return this.lan === 'cn' ? 'ad_cn2.png' : 'ad_en2.png';
          case 3:
            return this.lan === 'cn' ? 'ad_cn3.png' : 'ad_en3.png';
          default:
            return this.lan === 'cn' ? 'ad_cn1.png' : 'ad_en1.png';
        }
      };
    },
  },
  props: {
    show: Boolean,
    language: String,
  },
  methods: {
    goBack () {
      if (this.imgIndex > 1) this.imgIndex -= 1;
      this.imgShow();
    },
    goNext () {
      if (this.imgIndex < 3) this.imgIndex += 1;
      this.imgShow();
    },
    closeDialog () {
      this.homeTemplate.hideAdDialog();
    },
    imgShow () {
      this.imgOpacity = 0.1;
      for (let i = 0; i < 6; i += 1) {
        this.timerDelay = setTimeout(() => {
          this.imgOpacity += 0.2;
        }, 200 + i * 100);
      }
      clearTimeout(this.timerDelay);
    },
  },
};
</script>

<style lang="scss" scoped>
.ad-container {
  position: relative;
  .ad-close,
  .ad-skip,
  .ad-back,
  .ad-next {
    position: absolute;
    cursor: pointer;
    width: 48px;
    z-index: 1;
    top: 250px;
  }
  .ad-back {
    left: 0px;
  }
  .ad-next {
    right: 0px;
  }
  .ad-close {
    top: 0;
    right: 0;
  }
  .ad-skip {
    top: 10px;
    width: 60px;
    right: 70px;
  }
  .ad-img {
    position: absolute;
    top: 0px;
    left: 0;
    width: 740px;
  }
}
</style>
